import { useField } from 'formik'
import { FC, useState } from 'react'
import styled, { css } from 'styled-components'

interface SelectProps {
    name: string
    placeholder: string
    options: Array<string>
}

const Select: FC<SelectProps> = ({ name, options, ...props }) => {
    const [focus, setFocus] = useState(false)
    const [field, meta] = useField(name)

    return (
        <div>
            <InputWrapper {...{ focus }}>
                <select
                    {...field}
                    {...props}
                    onBlur={() => setFocus(false)}
                    onFocus={() => setFocus(true)}
                >
                    {options.map((i) => (
                        <option key={i} value={i}>
                            {i}
                        </option>
                    ))}
                </select>
            </InputWrapper>
            {meta.touched && meta.error && <div>{meta.error}</div>}
        </div>
    )
}

interface SearchProps {
    readonly focus: boolean
}

const InputWrapper = styled.div<SearchProps>`
    padding: 0 8px;
    border-radius: 5px;
    width: 100%;
    background: #f2f2f6;
    display: flex;
    align-items: center;
    margin-right: 16px;
    height: 50px;
    border: 1px solid transparent;
    transition: all 0.3s ease;

    select {
        border: none;
        background: transparent;
        width: 100%;
        color: #333;
        font-size: 16px;
        font-weight: 500;
        height: 100%;

        &:focus {
            outline: none;
        }
    }
    ${(props) =>
        props.focus &&
        css`
            border-color: rgba(101, 81, 204, 0.5);
            box-shadow: 0 0 0 0.3rem rgba(101, 81, 204, 0.1);
        `}
`

export { Select }
